import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

function Podcastlisting(porps) {

    return (
        <div className="podcast_listing tekrevol_gray_bg p-100">
            <Container>
                <Row>
                    <Col xs={12} md={12} lg={10} xl={10} xxl={10} className="mb-5">
                        <div className="example" data-text="Podcast Ep">
                            <h2>Latest Episodes</h2>
                        </div>
                        <p>We collaborate with entrepreneurs and industry leaders to emphasize the importance of digital
                            transformation. We regularly invite technopreneurs and change leaders to talk about how
                            technology played a crucial role in transforming their businesses and how it helps them
                            scale up with sustainability.</p>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                        <div className="podcast_list">
                            <h4>Mr. Jeetu Kataria, the Co-Founder, and CEO</h4>
                            <div className="podcast_txt">
                                <p>Mr. Jeetu Kataria shared some interesting insights with our host, Mr. Hady Shaikh, about the DIFX trading platform, the future of your Bitcoin, patent and licensing struggles in...</p>
                            </div>
                            <Link to="https://tekrevol.theservtech.com/podcastdetail/technology-for-change-season3-ep9"
                                  className="btn_podcast"> Listen to this Episode
                            </Link>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                        <div className="podcast_list">
                            <h4>Our Flagship Podcast with Mr. Jeremy Thomas</h4>
                            <div className="podcast_txt">
                                <p>Mr. Jeremy Thomas, the Founder and CEO of Astral Tech has an interesting take on how technology and digital enablement can help the energy and utility sectors enhance operationa...</p>
                            </div>
                            <Link to="https://tekrevol.theservtech.com/podcastdetail/technology-change-season3-episode08"
                                  className="btn_podcast"> Listen to this Episode
                            </Link>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                        <div className="podcast_list">
                            <h4>AI in Digital Media with Kate Bradley Chernis</h4>
                            <div className="podcast_txt">
                                <p>In the seventh episode of our podcast series, "Technology for a Change," our host and Principal Product Strategist, Mr. Hady Shaikh, has invited Ms. Kate Bradley Chernis, an AI-...</p>
                            </div>
                            <Link to="https://tekrevol.theservtech.com/podcastdetail/technology-change-season3-episode07"
                                  className="btn_podcast"> Listen to this Episode
                            </Link>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );

}


export default Podcastlisting;